import { Link, Tag, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { EInvoicesEmptyActivated } from '../../../../assets/images'
import { useSegment } from '../../../../hooks'
import { getImageClassName } from '../../../../utils/getClassName'
import { E_INVOICING_SUPPORT_LINK } from '../../constants'
import { useEInvoicingSetup } from '../../hooks/useEInvoicingSetup'
import { EInvoicingCerfaDownloadButton } from '../EInvoicingCerfaDownloadButton'
import * as Styled from './styles'

export const EInvoicingActivatedEmptyState = (): ReactElement => {
  const { t } = useTranslation()
  const { track } = useSegment()
  const { eInvoiceIntegration } = useEInvoicingSetup()
  const addressingLine = eInvoiceIntegration?.scope?.addressingLines?.[0]

  const handleCerfaDownloadClick = useCallback(() => {
    track('xxx - e-invoicing - Clicked "Download Proof"')
  }, [track])

  return (
    <Styled.StatusContainer>
      <Styled.StatusContent>
        <Styled.IllustrationContainer>
          <EInvoicesEmptyActivated className={getImageClassName()} />
        </Styled.IllustrationContainer>

        <Text variant="h3" alignment="center">
          {t('e_invoice.empty_state.activated.title')}
        </Text>

        <Tag color="green" type="subtle" icon="check" size="sm">
          {t('e_invoice.empty_state.activated.badge')}
        </Tag>

        <Text colorVariant="secondary" alignment="center">
          <Trans
            i18nKey={
              addressingLine
                ? 'e_invoice.empty_state.activated.subtitle'
                : 'e_invoice.empty_state.activated.subtitle_without_address'
            }
            values={{ address: addressingLine }}
            components={{
              a: <Link href={E_INVOICING_SUPPORT_LINK} target="_blank" rel="noopener noreferrer" />,
            }}
          />
        </Text>

        <EInvoicingCerfaDownloadButton onClick={handleCerfaDownloadClick} />
      </Styled.StatusContent>
    </Styled.StatusContainer>
  )
}
